import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Navbar from '../../components/Navbar'
import Item from '../../components/ProductCard'
import ld from '../../images/load.gif'
import styles from '../../styles/search.module.css'

function Search() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { id } = useParams()

  const getProducts = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`https://pro-shop-backend.vercel.app/api/products/search/${id}`)
      if (res.data.success) {
        setData(res.data.message)
      } else {
        toast.error(res.data.message || 'Failed to fetch search results', {
          position: 'bottom-right',
          theme: 'colored'
        })
        navigate('/')
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      const errorMessage = error.response?.data?.message || 'Failed to fetch search results. Please try again.'
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      })
      navigate('/')
    }
  }

  useEffect(() => {
    setData(null)
    getProducts()
  }, [id])

  return (
    <div className={styles.page}>
      <Navbar />

      <div className={styles.wrapper}>
        <h3 className={styles.heading}>
          Search results for <span>&quot;{id}&quot;</span>
        </h3>

        {loading || data === null ? (
          <div className={styles.loading}>
            <img src={ld} className={styles.loaderImage} alt="loader" />
          </div>
        ) : data.length === 0 ? (
          <div className={styles.empty}>
            <h4>No products found</h4>
            <p>Try a different search term or browse our full range.</p>
          </div>
        ) : (
          <div className={styles.grid}>
            {data.map((product) => (
              <Item key={product._id} data={product} />
            ))}
          </div>
        )}
      </div>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default Search